
<template>
  <!--添加广告-->
  <x-addEdit
    ref="addEdit"
    :apiOrigin="apiOrigin"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="$store.state.long_itemLayout"
  >
    <template slot="transfer" slot-scope="{formItem}">
      <a-form-item :label="formItem.label" required v-bind="$store.state.long_itemLayout">
        <Transfer ref="transfer"/>
      </a-form-item>
    </template>
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
import Transfer from '../../transfer.vue';
let decoratorOptions = {
  title: {
    validateTrigger: 'blur',
    rules: [
      { required: true, message: '请输入标题' },
      { min: 1, max: 50, message: '标题为1-50个字' },
      {pattern: /^([\s]*[\S]+[\s]*[\S]*)+$/, message: '不能为空'}
    ]
  },
  module: {
    rules: [{ required: true, message: '请选择应用' }]
  },
  scope_type: {
    rules: [{required: true, message: '请选择用户范围'}]
  },
  city_id: {
    rules: [{required: true, message: '请选择城市'}]
  },
  community_id: {
    rules: [{required: true, message: '请选择小区'}]
  },
  file_id: {
    rules: [{required: true, message: '请选择广告图'}]
  },
  content: {
    rules: [
      {required: true, message: '请输入链接地址'},
      {type: 'url', message: '请输入正确的url格式'}
    ]
  },
  order_id: {
    rules: [{required: true, message: '请输入排序编号'}, {pattern: /^([\s]*[\S]+[\s]*[\S]*)+$/, message: '不能为空'}]
  }
};
export default {
  mixins: [fetchSelect, addEdit],
  name: 'addAdvert',
  components: {
    Transfer
  },
  data () {
    return {
      apiOrigin: 'PHP',
      formKey: {
        title: '',
        module: '',
        scope_type: '',
        file_id: '',
        order_id: '',
        content: '',
        city_id: '',
        community_id: '',
        banner_space: '',
        open_type: '',
        activity_id: ''
      },
      formList: [
        {
          label: '标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入标题',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '应用',
          inputType: 'select',
          options: [],
          placeholder: '请选应用',
          handle: this.selectAppChagne,
          props: ['module', decoratorOptions.module]
        },
        {
          label: '用户范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          placeholder: '请选择用户范围',
          handle: e => this.handleUserRange(e),
          props: ['scope_type', decoratorOptions.scope_type]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: false,
          props: ['city_id', decoratorOptions.city_id]
        },
        {
          slot: 'transfer',
          label: '选择小区',
          inputType: 'text',
          options: [],
          placeholder: '请选择小区',
          titles: ['可选小区', '已选小区'],
          props: ['community_id', decoratorOptions.community_id]
        },
        {
          label: '广告位',
          inputType: 'select',
          options: [
            { label: '首页banner', value: 1 },
            { label: '发现展位', value: 2 }
          ],
          placeholder: '请选择广告位',
          props: ['banner_space', {rules: [{ required: true, message: '请选择广告位' }]}]
        },
        {
          label: '广告图',
          inputType: 'upload',
          options: [],
          placeholder: '',
          extra: '',
          fileList: [],
          uploadParam: {
            iconUrl: 'file_url',
            iconName: 'file_name',

            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['file_id', decoratorOptions.file_id]
        },
        {
          label: '点击后续动作',
          inputType: 'select',
          options: [
            { label: '打开url', value: 1 },
            { label: '打开活动', value: 2 },
            { label: '打开首页活动', value: 3 }
          ],
          placeholder: '请选择后续动作',
          handle: this.actionChange,
          props: ['open_type', {
            initialValue: 1,
            rules: [{required: true, message: '请选择后续动作'}]
          }]
        },
        {
          label: '链接',
          inputType: 'input',
          options: [],
          placeholder: '请输入链接',
          props: ['content', decoratorOptions.content]
        },
        {
          label: '活动',
          inputType: 'select',
          options: [],
          placeholder: '请选择活动',
          props: ['activity_id', {rules: [{ required: true, message: '请选择活动' }]}]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序编号',
          props: ['order_id', decoratorOptions.order_id]
        }
      ],
      addParam: {
        url: '/banner/add',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/banner/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/banner/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
    let keyArr = ['city_id', 'community_id', 'activity_id'];
    this.formList.forEach((el) => {
      let isSame = keyArr.some(item => item === (el.props && el.props[0]));
      isSame && (el.isShow = false);
    });
  },
  methods: {
    getSelect () {
      this.marketingManageSelect([{index: 1, key: 'banner_module_list', scope: 'formList'}]);

      this.provinceCitySelect((data) => {
        data && data.forEach((el) => {
          el.selectable = false;
          let children = el.children;
          if (children && children.length) {
            children.forEach((item) => {
              item.selectable = true;
            });
          }
        });
        this.formList[3].options = data;
      });

      this.communitySelect((data) => {
        let arr = [];
        data.community_list.forEach((el) => {
          arr.push({
            title: el.label,
            key: `${el.value}`
          });
        });
        this.formList[4].options = arr;
      });
    },
    selectAppChagne (e) {
      let index = this.gainListIndex(this.formList, 'file_id');
      if (e === 4) {
        this.formList[index].extra = '图片像素不大于690 * 160，文件不大于1MB';
      } else {
        this.formList[index].extra = '图片像素不大于666 * 260，文件不大于1MB';
      }
    },
    /** 后续动作 change事件 */
    actionChange (e) {
      let activityIndex = this.gainListIndex(this.formList, 'activity_id');
      let contentIndex = this.gainListIndex(this.formList, 'content');

      if (e === 1) {
        this.formList[contentIndex].isShow = true;
        this.formList[activityIndex].isShow = false;
      } else if (e === 2) {
        this.formList[contentIndex].isShow = false;
        this.formList[activityIndex].isShow = true;
        this.formList[activityIndex].label = '活动';
        this.formList[activityIndex].placeholder = '请选择活动';
        this.formList[activityIndex].inputType = 'select';
        this.formList[activityIndex].props = ['activity_id', {rules: [{ required: true, message: '请选择活动' }]}];
        this.marketingManageSelect((data) => {
          this.formList[activityIndex].options = data.activity_list;
        });
      } else {
        this.formList[contentIndex].isShow = false;
        this.formList[activityIndex].isShow = true;
        this.formList[activityIndex].label = '活动';
        this.formList[activityIndex].placeholder = '请输入首页活动ID';
        this.formList[activityIndex].inputType = 'input';
        this.formList[activityIndex].props = ['activity_id', {rules: [{ required: true, message: '请输入首页活动ID' }]}];
      }
    },
    /* 处理用户范围 */
    handleUserRange (val, formValues) {
      let scopeType = {
        0: { city_id: false, community_id: false },
        1: { city_id: true, community_id: false },
        2: { city_id: false, community_id: true }
      };
      this.formList.forEach(el => {
        let props = el.props && el.props[0];
        let scopeObj = scopeType[val];
        for (let item in scopeObj) {
          if (props === item) {
            if (item === 'community_id' && scopeObj[item]) {
              this.$refs.addEdit.form.setFieldsValue({community_id: []});
            } else if (scopeObj[item]) {
              this.$refs.addEdit.form.resetFields([item]);
            }
            el.isShow = scopeObj[item];
          }
        }
      });
      if (formValues) {
        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue(formValues);

          let arr = this.createCommunityId(formValues);
          arr.length && (this.$refs.addEdit.targetKeys = arr);
        });
      }
    },
    /** 生成小区id数组 */
    createCommunityId (formValues) {
      let arr = [];
      let communityId = formValues.community_id;
      communityId && Array.isArray(communityId) && communityId.forEach((el) => {
        el !== '0' && arr.push(el);
      });
      return arr;
    },
    /** 处理返回详情 */
    detailResHandle (res) {
      if (res.scope_type == 2) {
        setTimeout(() => {
          this.$refs.transfer.setTarget(res.community_id);
        }, 0);
      }

      let values = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = res[item];
        }
      }

      values.city_id && (values.city_id = `${values.city_id}`);

      this.selectAppChagne(values.module);
      this.actionChange(values.open_type);
      this.handleUserRange(res.scope_type, values);
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      if (Array.isArray(param.community_id)) {
        param.community_id = param.community_id.join(',');
      }
      let arealist = this.$refs.transfer && this.$refs.transfer.targetKeys;
      if (param.scope_type == 2 && arealist.length == 0) {
        this.$message.error('请选择小区');
        return;
      }
      if (param.scope_type == 2 && arealist.length != 0) {
        param.community_id = arealist.join();
      }

      return param;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
